const passkey_sign_in = {
    setup_page: {
        title: 'Simplifiez votre connexion',
        subtitle: 'Créez une clé d’accès',
        description: 'Enregistrez votre clé d’accès à l’aide des données biométriques de l’appareil, de clés de sécurité comme YubiKey ou d’autres méthodes disponibles.',
    },
    trigger_conditional_ui_failed: 'Échec du déclenchement du remplissage automatique par passkey.',
};
export default Object.freeze(passkey_sign_in);
